export const GET_DATA = 'GET_USERS';
export const DATA_ERROR = 'USERS_ERROR';
